import React from 'react';
import classNames from 'classnames';

import { CharacterStates } from '../../../utils/constants';

interface IProps {
  file?: AnnotationFile;
  windowSize: string;
}

const Character = ({ file, windowSize }: IProps) => {
  const { url, state } = file || {};

  // Generate Alt-text
  let altText = '';
  switch (state) {
    case CharacterStates.Neutral:
      altText = 'Character with pleasant demeanor.';
      break;
    case CharacterStates.TryAgain:
      altText = 'Character with slightly disappointed demeanor.';
      break;
    case CharacterStates.Incorrect:
      altText = 'Character with disappointed demeanor.';
      break;
    case CharacterStates.Correct:
      altText = 'Character with excited demeanor.';
      break;
    default:
      altText = 'Character.';
  }

  return (
    <div className={classNames('Character', windowSize)}>
      <img className={classNames('Character-image')} src={url} alt={altText} aria-hidden="true" />
    </div>
  );
};

export default Character;
